import React from 'react'

interface TravelProps {
    height?: number
    width?: number
}

const Travel: React.FC<TravelProps> = ({ height, width }) => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width={width}
            height={height}
            fill='none'
            viewBox='0 0 20 20'
        >
            <path
                d='M8.35482 17.2918L6.37565 13.6252L2.70898 11.646L4.10482 10.2293L7.12565 10.7502L9.14648 8.75016L2.70898 5.97933L4.47982 4.2085L12.2298 5.646L14.7298 3.146C15.0215 2.85433 15.3757 2.7085 15.7923 2.7085C16.209 2.7085 16.5632 2.85433 16.8548 3.146C17.1465 3.43766 17.2923 3.78836 17.2923 4.19808C17.2923 4.6078 17.1465 4.9585 16.8548 5.25016L14.3548 7.75016L15.7923 15.521L14.0215 17.2918L11.2507 10.8543L9.25065 12.8752L9.77148 15.896L8.35482 17.2918Z'
                fill='currentColor'
            />
        </svg>
    )
}

Travel.defaultProps = {
    height: 20,
    width: 20
}

export default Travel
